class SearchForm extends HTMLElement {
  constructor() {
    super();

    /*
     * All theme search fields use type="search".
     */
    this.input = this.querySelector(
      'input[type="search"]'
    );

    this.resetButton = this.querySelector(
      'button[type="reset"]'
    );

    if (!this.input) {
      return;
    }

    if (this.input.form) {
      this.input.form.addEventListener(
        'reset',
        this.onFormReset.bind(this)
      );
    }

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300)
    );

    /*
     * Ensure the reset button state
     * is correct immediately.
     */
    this.toggleResetButton();
  }

  toggleResetButton() {
    if (
      !this.input ||
      !this.resetButton
    ) {
      return;
    }

    const hasValue =
      this.input.value.length > 0;

    this.resetButton.classList.toggle(
      'hidden',
      !hasValue
    );
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    /*
     * Scope the check to the current
     * search component only.
     *
     * Prevents another predictive-search
     * instance from affecting this one.
     */
    return !this.querySelector(
      '[aria-selected="true"] a, ' +
      'button[aria-selected="true"]'
    );
  }

  onFormReset(event) {
    /*
     * Prevent the browser from restoring
     * the original URL-loaded search value.
     */
    event.preventDefault();

    /*
     * Do not clear while a predictive
     * search result is being selected.
     */
    if (!this.shouldResetForm()) {
      return;
    }

    if (!this.input) {
      return;
    }

    this.input.value = '';

    this.input.focus();

    this.toggleResetButton();
  }
}

if (
  !customElements.get(
    'search-form'
  )
) {
  customElements.define(
    'search-form',
    SearchForm
  );
}